import {
  ContainerMFE,
  FeatureFlagKeyValues,
  LookingForSomethingElse,
  publishEvent,
  SectionHeader,
  useGetFeatureFlags
} from '@uma/react-commons/dist/index';
import React, { useEffect, useMemo } from 'react';
import ManageOrdersSection from 'src/components/ManageOrdersSection';
import MoreOptions from 'src/components/MoreOptions';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import { ScreenName, ScreenPath } from 'src/utils/constants';
import { OrdersScreenDisplayed } from './analytics';
import { Header } from './styles';

export interface FeatureFlagProps {
  ordersCountryBasedExperience: boolean;
  isLoading: boolean;
}

export const OrdersPage = (): React.JSX.Element => {
  const { translate, northboundAPIs } = useDependencyManagerContext();

  const featureFlagClient = useMemo(
    () => northboundAPIs?.v1?.featureFlags?.getClient,
    [northboundAPIs?.v1?.featureFlags?.getClient]
  );

  const {
    ordersCountryBasedExperience,
    originalFeedbackExperience,
    isLoading
  } = useGetFeatureFlags({
    getClient: featureFlagClient,
    keys: [
      FeatureFlagKeyValues.ordersCountryBasedExperience,
      FeatureFlagKeyValues.originalFeedbackExperience
    ]
  });

  const showOriginalFeedbackExperience =
    originalFeedbackExperience && !isLoading;

  useEffect(() => {
    publishEvent(OrdersScreenDisplayed);
  }, []);

  return (
    <ContainerMFE data-testid="orders-page">
      <Header>
        <SectionHeader
          title={translate('orders.ordersLabel', 'Orders')}
          subtitle={translate(
            'orders.viewAndManagePurchase',
            'View and manage your purchases'
          )}
        />
      </Header>
      <ManageOrdersSection
        {...{
          isLoading,
          ordersCountryBasedExperience
        }}
      />
      <MoreOptions
        {...{
          isLoading,
          ordersCountryBasedExperience
        }}
      />
      {showOriginalFeedbackExperience && (
        <LookingForSomethingElse
          analytics={{
            screenName: ScreenName,
            screenPath: ScreenPath
          }}
        />
      )}
    </ContainerMFE>
  );
};
